import React, { Component } from 'react';
import Countdown, { zeroPad } from 'react-countdown-now';
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaSpinner,
  FaInfoCircle,
} from 'react-icons/fa';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import api from '../../axios-local-api';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import DeviceList from '../DeviceList/DeviceList';
import Counter from '../../components/Counter';
import WifiHealth from '../WifiHealth/WifiHealth';
import PodPerformance from './PodPerformance/PodPerformance';
import RouterPerformance from './RouterPerformance/RouterPerformance';
import classes from './WifiServiceCheck.css';
import { EquipmentTypes } from '../../shared/common';

export class WifiServiceCheck extends Component {
  constructor(props) {
    super(props);

    this.state = {
      wifiHealthOpen: false,
      displayFullReport: false,
      upArrow: false,
      displayInitialReport: false,
      rendererFn: () => { },
      wscStartedAt: 0,
    };
    this.startWifiServiceCheck = this.startWifiServiceCheck.bind(this);
    this.getWifiServiceCheckFullReport =
      this.getWifiServiceCheckFullReport.bind(this);
    this.makeRendererFn = this.makeRendererFn.bind(this);
  }

  makeRendererFn() {
    return ({ minutes, seconds }) => {
      if (seconds >= 5) {
        return <p>ERROR</p>
      }
      return (
        <span>
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    };
  }

  componentDidMount() {
    if (
      this.props.location &&
      this.props.location.query &&
      this.props.location.query.wifiServiceCheckPageOpen
    ) {
      this.startWifiServiceCheck();
      this.getWifiServiceCheckFullReport();
    }
  }

  componentWillUpdate() { }

  componentDidUpdate() { }

  handleWifiHealthOpen() {
    this.setState({
      wifiHealthOpen: true,
    });
  }

  startWifiServiceCheck() {
    const t = Date.now()
    this.props.onRefreshDevices(this.props.selectedEquipment);
    this.props.runWifiServiceCheck();
    this.setState({
      displayInitialReport: true,
      wscStartedAt: t,
      rendererFn: this.makeRendererFn(t),
    });
  }


  getWifiServiceCheckFullReport() {
    if (!this.state.displayFullReport) {
      this.setState({
        displayFullReport: true,
      });
    } else {
      this.setState({
        displayFullReport: false,
      });
    }
    this.handleViewReportHandler();
  }
  handleViewReportHandler() {
    if (!this.state.upArrow) {
      this.setState({
        upArrow: true,
      });
    } else {
      this.setState({
        upArrow: false,
      });
    }
  }


  render() {
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} style={{}} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }

    const disableRunCheck = !!(this.props.enablementStaus === "noService"
                          && !sessionStorage.getItem("type")?.includes("undefined")
                          && !sessionStorage.getItem("type")?.includes("unknown")
                          && !sessionStorage.getItem('type')?.includes('Business'));

    let wifiServiceCheckReport;
    let wifiServiceRouterStatus;
    let wifiServiceRouterFailedCount = 0;
    let wifiServicePodsFailedCount = 0;
    let wifiServicePodsStatus = <div />;
    let wifiServicePodsBool = false;
    let wifiServicePodsCalStatus = 0;
    let wifiSeriviceDevicesFailedCount = 0;
    let wifiServiceDeviceCalStatus = 0;
    let qoePods = [];
    let qoeDevices = [];
    let showError = this.props.wscFailed
      ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <div>
            Something went wrong. Please try again shortly.
          </div>
        </div>)
      : (<span />)

    if (
      this.props.realWan &&
      this.props.realWan.health &&
      Number(this.props.realWan.health.score) >= 3 &&
      this.props.realWan.connectionState === 'connected'
    ) {
      wifiServiceRouterStatus = (
        <div>
          <div className={classes.ListItemOuter}>
            <div className={classes.ListLeftSide}>
              <div
                id='wifiServiceRouter'
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <FaCheckCircle
                  color={'green'}
                  style={{ marginRight: '5px' }}
                  fontSize={'20px'}
                />
                Router
              </div>
            </div>
            <div
              className={classes.Upright}
              style={{ width: '170px', textAlign: 'right' }}
            >
              <div id='wifiServiceRouterStatus'>Pass</div>
            </div>
          </div>
        </div>
      );
    } else {
      wifiServiceRouterStatus = (
        <div>
          <div className={classes.ListItemOuter}>
            <div className={classes.ListLeftSide}>
              <div
                id='wifiServiceRouter'
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <FaExclamationCircle
                  color={'red'}
                  style={{ marginRight: '5px' }}
                  fontSize={'20px'}
                />
                Router
              </div>
            </div>
            <div
              className={classes.Upright}
              style={{ width: '170px', textAlign: 'right' }}
            >
              <div id='wifiServiceRouterStatus'>Fail</div>
            </div>
          </div>
        </div>
      );
      wifiServiceRouterFailedCount = 1;
    }
    if (
      this.props.qoeScores &&
      this.props.qoeScores.nodes &&
      this.props.qoeScores.nodes.length
    ) {
      wifiServicePodsBool = true;
    }
    // this.props.claimedPods.filter((pod) => {
    //   if (
    //     pod.connectionState === 'disconnected' ||
    //     pod.connectionState === 'poor' ||
    //     pod.connectionState === 'Poor' ||
    //     pod.connectionState === 'unavailable'
    //   ) {
    //     return true;
    //   }
    //   return false;
    // });
    // console.log('props qoeScores :::', this.props);
    if (
      this.props.qoeScores &&
      this.props.qoeScores.nodes &&
      this.props.qoeScores.nodes.length
    ) {
      this.props.qoeScores.nodes.forEach((pod) => {

        // Adding condition to handle the calculating status
        this.props.claimedPods.filter((cPod) => {
          if(cPod.connectionState === 'disconnected' || cPod.health.status === 'disconnected'){
            return;
          }
          qoePods.push(pod.nodeId);
          // console.log('cPod.health :::', cPod.health);
          // if (pod.nodeId === cPod.id) {
            // if ((cPod.health && (cPod.health.status === 'calculating' || cPod.health.status === 'Calculating'))
            // ) {
            //   wifiServicePodsCalStatus++;
            //   qoePods.push(pod.nodeId);
            // } else if (
            //   Number(pod.weightedQoeScore) < 3 ||
            //   pod.weightedQoeScore === 'N/A' ||
            //   !pod.weightedQoeScore
            // ) {
            //   wifiServicePodsFailedCount++;
            //   qoePods.push(pod.nodeId);
            // }

          // }

        });



      });
    }

    if (wifiServicePodsBool) {
      if (wifiServicePodsFailedCount > 0) {
        wifiServicePodsStatus = (
          <Box>
            <div>
              <div className={classes.ListItemOuter}>
                <div className={classes.ListLeftSide}>
                  <div
                    id='wifiServicePods'
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <FaExclamationCircle
                      color={'red'}
                      style={{ marginRight: '5px' }}
                      fontSize={'20px'}
                    />
                    Extenders
                  </div>
                </div>

                <div
                  className={classes.Upright}
                  style={{ width: '170px', textAlign: 'right' }}
                >
                  <div
                    className={classes.showDesktop}
                    id='wifiServicePodsStatus'
                  >
                    Fail, {wifiServicePodsFailedCount} issues found
                  </div>
                  <div
                    className={classes.showMobile}
                    id='wifiServicePodsStatus'
                  >
                    {wifiServicePodsFailedCount} issues found
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.Separator} />
          </Box>
        );

      } else {
        wifiServicePodsStatus = (
          <Box>
            <div>
              <div className={classes.ListItemOuter}>
                <div className={classes.ListLeftSide}>
                  <div
                    id='wifiServicePods'
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    {
                      wifiServicePodsCalStatus > 0 &&
                      <FaCheckCircle
                        color={'orange'}
                        style={{ marginRight: '5px' }}
                        fontSize={'20px'}
                      />
                    }
                    {
                      wifiServicePodsCalStatus === 0 &&
                      <FaCheckCircle
                        color={'green'}
                        style={{ marginRight: '5px' }}
                        fontSize={'20px'}
                      />
                    }
                   Extenders 
                  </div>
                </div>

                <div
                  className={classes.Upright}
                  style={{ width: '170px', textAlign: 'right' }}
                >
                  {
                    wifiServicePodsCalStatus > 0 &&
                    <div
                      id='wifiServicePodsStatus'
                    >
                      N/A
                    </div>
                  }
                  {
                    wifiServicePodsCalStatus === 0 &&
                    <div id='wifiServicePodsStatus'>Pass</div>
                  }

                </div>
              </div>
            </div>
            <div className={classes.Separator} />
          </Box>
        );
      }
    }
    // else {
      // wifiServicePodsStatus = (
      //   <div>
      //   <div className={classes.ListItemOuter}>
      //     <div className={classes.ListLeftSide}>
      //       <div id = 'wifiServicePods'style={{ display: 'flex', alignItems: 'center' }}>
      //         Pods
      //       </div>
      //     </div>
      //   </div>
      // </div>
      // )
    //   wifiServicePodsStatus = <div />;
    // }
    // console.log('realDevices :::', this.props.realDevices);
    if (
      this.props.qoeScores &&
      this.props.qoeScores.devices &&
      this.props.qoeScores.devices.length &&
      this.props.realDevices &&
      this.props.realDevices.length
    ) {
      this.props.realDevices.forEach((device) => {
        // restricting the ethernet connected devices
        if (device.medium === "ethernet") {
          return;
        }
        // Checking the qoe device is available
        this.props.qoeScores.devices.forEach((d) => {
          if (d.mac === device.mac) {
            // Checking for the devices with calculating statuses
            if (device.health && (device.health.status === 'calculating' || device.health.status === 'Calculating')) {
              wifiServiceDeviceCalStatus++;
              qoeDevices.push(device);
            } else if (device.connectionState !== 'connected') {
              // Initial Checking whether the device is connected or not
              wifiSeriviceDevicesFailedCount++;
              // device.weightedQoeScore = d.weightedQoeScore;
              qoeDevices.push(device);
            } else {
              //console.log('weightedScore ::::',d.weightedQoeScore)
              // Checking the health of the device
              if (
                d.weightedQoeScore < 3 ||
                d.weightedQoeScore === 'N/A' ||
                !d.weightedQoeScore
              ) {
                wifiSeriviceDevicesFailedCount++;
                // device.weightedQoeScore = d.weightedQoeScore;
                qoeDevices.push(device);
              }
            }
            if (
              device.deviceSignalStatus === 'N/A'
              //   device.deviceSignalStatus === 'poor' ||
              //   device.deviceSignalStatus === 'Poor' ||
              //   device.deviceSignalStatus === 'Calculating' ||
              //   device.deviceSignalStatus === 'calculating' ||
              //   device.deviceSignalStatus === 'Paused'
            ) {
              // device.weightedQoeScore = d.weightedQoeScore;
              qoeDevices.push(device);
            }
          }
        });
      });
    }
    // console.log('device qoe :::', qoeDevices);
    let wifiServiceCheckOverallPerf = 'Pass';
    let wifiServiceCheckOverallPerfColor = { color: 'green' };
    // console.log('wifiSeriviceDevicesFailedCount :::', wifiSeriviceDevicesFailedCount, 'wifiServicePodsFailedCount ::', wifiServicePodsFailedCount)
    if (
      wifiSeriviceDevicesFailedCount > 0 ||
      wifiServicePodsFailedCount > 0 ||
      (this.props.realWan &&
        this.props.realWan.health &&
        Number(this.props.realWan.health.score) < 3) ||
      (this.props.realWan &&
        this.props.realWan.connectionState === 'disconnected') ||
      (this.props.realWan &&
        this.props.realWan.connectionState === 'unavailable')
    ) {
      wifiServiceCheckOverallPerf = 'Fail';
      wifiServiceCheckOverallPerfColor = { color: 'red' };
    }
    if (wifiSeriviceDevicesFailedCount === 0 && wifiServicePodsFailedCount === 0 &&
      (wifiServiceDeviceCalStatus > 0 || wifiServicePodsCalStatus > 0)
    ) {
      wifiServiceCheckOverallPerf = 'N/A';
      wifiServiceCheckOverallPerfColor = { color: 'orange' };
    }
    let viewFullReportBtnDesktopHtml = (
      <Box>
        <div className={[classes.Spacer, classes.showDesktop].join(' ')} />
        <div
          className={[classes.FullReportItem, classes.showDesktop].join(' ')}
        >
          <div className={classes.Upright}>
            <div
              id='wifiServiceViewFullReport'
              style={{ display: 'flex' }}
              onClick={() => {
                this.getWifiServiceCheckFullReport();
              }}
            >
              {arrow}
              <button
                id='wifiServiceViewFullReportBtn'
                className={classes.RegularButton}
              >
                View Full Report
              </button>
            </div>
          </div>
        </div>
        <div className={[classes.Spacer, classes.showDesktop].join(' ')} />
        <div className={classes.Spacer} />
      </Box>
    );

    let BtnName = this.state.displayFullReport
      ? 'Back To Summary'
      : 'View Full Report';

    let viewFullReportBtnMobileHtml = (
      <Box>
        <div className={[classes.FullReportItem, classes.showMobile].join(' ')}>
          <div>
            {/* <div id = 'wifiServiceViewFullReport' style={{display:'flex'}} onClick={() => {
              this.getWifiServiceCheckFullReport()
            }} > */}

            {/* <button
              id='wifiServiceViewFullReportBtn'
              className={classes.RegularButtonMobile}
              onClick={() => {
                this.getWifiServiceCheckFullReport();
              }}
            >
              {BtnName}
            </button> */}
            {/* </div> */}
          </div>
        </div>
        <div className={classes.Spacer} />
        <div className={classes.Spacer} />
      </Box>
    );
    if (this.state.displayInitialReport) {
      if (!this.props.wscFailed && this.props.wan && this.props.wan.wifiServiceCheckTimer) {
        wifiServiceCheckReport = (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <div>
              <FaSpinner
                fontSize={'25px'}
                style={{ color: '#0073d1', marginRight: '5px' }}
                className={[
                  classes.fa,
                  classes.facircleonotch,
                  classes.faspin,
                  classes.fa3x,
                  classes.fafw,
                ].join(' ')}
              />
            </div>
            Please wait for the WiFi Service Check to complete.
            <br />
            <Counter
              startDate={this.state.wscStartedAt}
            />
          </div>
        );

      } else {
        //  wifiSeriviceDevicesFailedCount = 0;
        let wifiServiceDevicesSection;
        if (wifiSeriviceDevicesFailedCount > 0) {
          wifiServiceDevicesSection = (<FaExclamationCircle
            color={'red'}
            style={{ marginRight: '5px' }}
            fontSize={'20px'}
          />
          );
        } else if (wifiSeriviceDevicesFailedCount === 0 && wifiServiceDeviceCalStatus > 0) {
          wifiServiceDevicesSection = (<FaExclamationCircle
            color={'orange'}
            style={{ marginRight: '5px' }}
            fontSize={'20px'}
          />);
        } else if (wifiSeriviceDevicesFailedCount === 0) {
          wifiServiceDevicesSection = (<FaCheckCircle
            color={'green'}
            style={{ marginRight: '5px' }}
            fontSize={'20px'}
          />);
        }


        wifiServiceCheckReport = (
          <Box>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
              <div
                style={{
                  width: '25%',
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center',
                }}
              >
                <h1 id='WSCOverallPerformanceStatus' style={wifiServiceCheckOverallPerfColor}>
                  {' '}
                  {wifiServiceCheckOverallPerf}{' '}
                </h1>
                <span style={{ color: 'grey' }}>
                  {' '}
                  Overall Performance{' '}
                </span>
              </div>
              <div style={{ width: '75%' }}>
                {wifiServiceRouterStatus}
                <div className={classes.Separator} />
                {this.props.qoeScores &&
                  this.props.qoeScores.nodes &&
                  wifiServicePodsStatus}
                {this.props.qoeScores && this.props.qoeScores.devices && (
                  <div>
                    <div className={classes.ListItemOuter}>
                      <div className={classes.ListLeftSide}>
                        <div
                          id='wifiServiceDevices'
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {wifiServiceDevicesSection}
                          Devices
                        </div>
                      </div>

                      <div
                        className={classes.Upright}
                        style={{ width: '170px', textAlign: 'right' }}
                      >
                        <div
                          className={classes.showDesktop}
                          id='wifiServiceDevicesStatus'
                        >
                          {wifiSeriviceDevicesFailedCount > 0
                            ? 'Fail, ' +
                            wifiSeriviceDevicesFailedCount +
                            ' issues found'
                            : (wifiSeriviceDevicesFailedCount === 0 && wifiServiceDeviceCalStatus > 0
                              ? 'N/A' : 'Pass')}

                        </div>
                        <div
                          className={classes.showMobile}
                          id='wifiServiceDevicesStatus'
                        >
                          {wifiSeriviceDevicesFailedCount > 0
                            ? wifiSeriviceDevicesFailedCount + ' issues found'
                            : (wifiSeriviceDevicesFailedCount === 0 && wifiServiceDeviceCalStatus > 0
                              ? 'N/A' : 'Pass')}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className={classes.Separator} />

                {(wifiServiceCheckOverallPerf === 'N/A' || wifiServiceCheckOverallPerf === 'Fail') ? (
                  viewFullReportBtnDesktopHtml
                ) : (
                  <div className={classes.Spacer} />
                )}
              </div>
            </div>
          </Box>
        );
      }
    }

    let handleTopology = sessionStorage.getItem('handleTopology');
    let techMobile = sessionStorage.getItem('techMobile');
    let wifiHealth;
    let wifiHealthContainer;

    if (
      this.props.selectedEquipment.type === EquipmentTypes.Pod ||
      this.props.selectedEquipment.type === EquipmentTypes.Router
    ) {
      wifiHealthContainer = <div />;
      wifiHealth = <div />;
    } else {
      wifiHealth = (
        <Box>
          <WifiHealth />
          <div className={classes.Spacer} />
        </Box>
      );
    }

    wifiHealthContainer = wifiHealth;

    if (this.props.selectedEquipment.type === EquipmentTypes.Equipment) {
      if (handleTopology && handleTopology.includes('hideAll')) {
        wifiHealthContainer = <div />;
      }
      if (
        techMobile &&
        (techMobile === 'true' || techMobile === true) &&
        handleTopology &&
        handleTopology.includes('hideTM')
      ) {
        wifiHealthContainer = <div />;
      } else if (
        (!techMobile ||
          (techMobile && techMobile === 'false') ||
          (techMobile && techMobile === false)) &&
        handleTopology &&
        handleTopology.includes('hideGW')
      ) {
        wifiHealthContainer = <div />;
      }

      if (
        !this.state.wifiHealthOpen &&
        ((techMobile &&
          (techMobile === 'true' || techMobile === true) &&
          handleTopology &&
          handleTopology.includes('maskTM')) ||
          ((!techMobile ||
            (techMobile && (techMobile === 'false' || techMobile === false))) &&
            handleTopology &&
            handleTopology.includes('maskGW')))
      ) {
        wifiHealthContainer = (
          <Box>
            <div className={classes.WifiHealth}>
              <div className={classes.TitleArea}>
                <div className={classes.TitleLeft}>
                  <h3 style={{ paddingRight: 20 }}>Router Health</h3>
                </div>
                <div className={classes.TitleRight}>
                  <button
                    className={classes.RegularButton}
                    onClick={() => {
                      this.handleWifiHealthOpen();
                    }}
                  >
                    Get Data
                  </button>
                </div>
              </div>
            </div>
          </Box>
        );
      }
    } else {
      wifiHealthContainer = <div />;
    }

    let routerPerformance;
    routerPerformance = (
      <RouterPerformance
        wifiServiceRouterFailedCount={wifiServiceRouterFailedCount}
      />
    );

    let podPerformance;
    if (
      this.props.qoeScores &&
      this.props.qoeScores.nodes &&
      this.props.qoeScores.nodes.length
    ) {
      podPerformance = (
        <PodPerformance
          wifiServicePodsFailedCount={wifiServicePodsCalStatus > 0 ? wifiServicePodsCalStatus : wifiServicePodsFailedCount}
          qoePods={qoePods}
        />
      );
    }
    let devicesList;

    let TDCSisGroupPauseEnabled = sessionStorage.getItem('groupEnabled');
    // console.log('tdcs????', TDCSisGroupPauseEnabled);
    if (TDCSisGroupPauseEnabled === 'disabled') {
      TDCSisGroupPauseEnabled = false;
    } else {
      TDCSisGroupPauseEnabled = true;
    }
    let deviceDisplayMsg = '';
    if (wifiSeriviceDevicesFailedCount == 0) {
      deviceDisplayMsg = 'All connected devices have passed service check';
    }
    if (
      this.props.qoeScores &&
      this.props.qoeScores.devices &&
      this.props.qoeScores.devices.length
    ) {
      devicesList = (
        <DeviceList
          devicesByEquipment={qoeDevices}
          hideSpeedBoostColumn
          radioInfo={this.props.radioInfo}
          realWan={this.props.realWan}
          enableGroupPause={TDCSisGroupPauseEnabled}
          displayPoorAndDisConnectedDevices={true}
          deviceDisplayMsg={deviceDisplayMsg}
        />
      );
    }

    let viewReportDetails;
    let reportBodyArea;
    if (this.state.displayFullReport) {
      viewReportDetails = (
        <Box>
          <div className={[classes.Spacer, classes.showDesktop].join(' ')} />
          {routerPerformance}
          <div className={classes.Spacer} />
          {podPerformance}
          <div className={classes.Spacer} />
          {devicesList}
          <div className={classes.Spacer} />
        </Box>
      );
    } else {
      viewReportDetails = <div />;
    }
    if (this.state.displayInitialReport) {
      if (this.props.wan && this.props.wan.wifiServiceCheckTimer) {
        reportBodyArea = (
          <div className={classes.BodyArea}>{wifiServiceCheckReport}</div>
        );
      } else {
        reportBodyArea = (
          <div className={classes.BodyArea}>
            {wifiServiceCheckReport}
            {viewReportDetails}
            {wifiHealthContainer}
            {wifiServiceCheckOverallPerf === 'Fail' &&
              viewFullReportBtnMobileHtml}
          </div>
        );
      }

    } else {
      reportBodyArea = <div />;
    }

    let runCheckDisable = {};
    let disableWsc = false;
    if (
      this.props.checkingWan ||
      (this.props.podTimer && this.props.rebootPodId)
      ||((this.props.realWan  &&
        this.props.realWan.connectionState === 'unavailable')
        || (this.props.realWan  &&
          this.props.realWan.connectionState === 'disconnected'))
    ) {

      runCheckDisable = {
        background: 'none',
        pointerEvents: 'none',
        opacity: '0.5',
        color: 'dimgrey',
      };
      disableWsc = true;
    }
    // console.log('runCheckDisable :::', disableWsc, disableRunCheck);

    return (
      <Box>
        <div className={classes.WifiHealth}>
          <div className={classes.TitleArea}>
            <div className={classes.TitleLeft}>
              <h3 className={classes.ComponentTitle}>WiFi Service Check</h3>
            </div>
            <div className={classes.TitleRight} title={disableWsc ? 'Router must be online to run WiFi Service Check' : ''}>
              <button
                style={runCheckDisable}
                id='wifiServiceCheck'
                className={classes.RegularButton}
                onClick={() => {
                  this.startWifiServiceCheck();
                }}
                disabled={this.props.checkingWan && this.props.timerStart
                  || this.props.wan.podTimer && this.props.wan.rebootPodId
                  || disableRunCheck}

              >
                Run Check
              </button>
            </div>
          </div>
          {this.props.wscError && this.state.displayInitialReport &&
          (<div className={[classes.alertMessageContainer, classes.limitedFunctionalityAlertMessage]. join(' ')} >
              <span>
                <FaExclamationCircle id ='WSCAlertIcon' color='red' size={24} />
              </span>
              <span id='WSCLimitedMsg' style={{marginLeft:'10px'}}>
                {' '}
                    Something went wrong, please try again.
                {' '}
              </span>
            </div>)
            }

          {((!this.state.displayInitialReport || disableWsc) && !disableRunCheck) && (
            <div className={[classes.alertMessageContainer].join(' ')}>
              <span>
                <FaInfoCircle color='#38a9f9' size={24} />
              </span>
              <span id='WSCTestMsg' className={classes.alertMessage}>
                {' '}
                The WiFi Service Check will run an analysis for WiFi health on the Router, Extenders and select stationary devices.{' '}
              </span>
            </div>
          )}
          { disableRunCheck &&
            <div className={[classes.alertMessageContainer, classes.limitedFunctionalityAlertMessage].join(' ')} >
            <span>
              <FaExclamationCircle id ='WSCAlertIcon' color='red' size={24} />
            </span>
            <span id='WSCLimitedMsg' style={{marginLeft:'10px'}}>
              {' '}
              WiFi Service Check is currently disabled
              {' '}
            </span>
          </div>
          }
          <div className={classes.Separator} />
          {this.props.wscFailed && showError}
          {!this.props.wscError && !this.props.wscFailed && !disableWsc && reportBodyArea}
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => (
  {
    realDevices: state.devices.realDevices,
    devicesByEquipment: state.devices.devicesByEquipment,
    selectedEquipment: state.equipment.selectedEquipment,
    wan: state.wan,
    realWan: state.wan.realWan,
    radioInfo: state.devices.radioInfo,
    equipment: state.equipment,
    claimedPods: state.equipment.realEquipment
      ? state.equipment.realEquipment.claimedPods
      : [],
    location: state.router.location,
    checkingWan: state.wan.checkingWan,
    qoeScores: state.qoe.qoeScores,
    wscFailed: state.wan.wscError,
    enablementStaus: state.spectrumReady.status,
  }
)

const mapDispatchToProps = (dispatch) => ({
  runWifiServiceCheck: () => dispatch(actions.runWifiServiceCheck()),
  onRefreshDevices: (selectedEquipment) => dispatch(actions.refreshDevices(selectedEquipment))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withErrorHandler(WifiServiceCheck, api)));
